import React from 'react';
import PropTypes from 'prop-types';
import { UHCUpdates } from './UHCUpdates';

export const Widget = (props) => {
  return <UHCUpdates {...props} />;
};

Widget.displayName = 'utility/UHCUpdatesWidget';

Widget.propTypes = {
  data: PropTypes.shape({}),
};

Widget.defaultProps = {
  data: {},
};
